import React from "react";
import { BillingOverviewSection } from "./sections/BillingOverviewSection";
import { UsageAnalyticsSection } from "./sections/UsageAnalyticsSection";
import { UsageHistorySection } from "./sections/UsageHistorySection";
import { RunHistorySection } from "./sections/RunHistorySection";
import { SupportSection } from "./sections/SupportSection";

export const UsageTab: React.FC = () => {
  return (
    <div className="flex flex-col gap-8">
      {/* Billing Overview Section */}
      <BillingOverviewSection />

      {/* Usage Analytics Section with Chart */}
      <UsageAnalyticsSection />

      {/* Usage History Table Section */}
      <UsageHistorySection />

      {/* Run History Table Section */}
      <RunHistorySection />

      {/* Support Section */}
      <SupportSection />
    </div>
  );
};
